var map = {
	"./age_green.svg": [
		1232,
		133
	],
	"./age_red.svg": [
		1233,
		134
	],
	"./age_yellow.svg": [
		1234,
		135
	],
	"./duration_green.svg": [
		1235,
		136
	],
	"./duration_orange.svg": [
		1236,
		137
	],
	"./duration_red.svg": [
		1237,
		138
	],
	"./duration_yellow.svg": [
		1238,
		139
	],
	"./logo.svg": [
		650
	],
	"./ltv_green.svg": [
		1239,
		140
	],
	"./ltv_orange.svg": [
		1240,
		141
	],
	"./ltv_red.svg": [
		1241,
		142
	],
	"./ltv_yellow.svg": [
		1242,
		143
	],
	"./nhg_no.svg": [
		1243,
		144
	],
	"./nhg_unknown.svg": [
		1244,
		145
	],
	"./nhg_yes.svg": [
		1245,
		146
	],
	"./pension_green.svg": [
		1246,
		147
	],
	"./pension_orange.svg": [
		1247,
		148
	],
	"./pension_red.svg": [
		1248,
		149
	],
	"./pension_yellow.svg": [
		1249,
		150
	],
	"./result_negative.svg": [
		1205
	],
	"./result_positive.svg": [
		1204
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1219;
module.exports = webpackAsyncContext;